import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';
import { GeneralService } from '@app-services/general/general.services';
import { AuthService } from '@app-core/services/auth/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SwalService } from '@app-services/swal/swal.service';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
})
export class UserSettingsComponent implements OnInit, OnDestroy {
  // unsubscribe
  private ngUnsubscribe$: Subject<any> = new Subject();

  public userInfo;
  public user;
  public accountForm: FormGroup;
  public passwordForm: FormGroup;

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private service: GeneralService,
    private authService: AuthService,
    private swalService: SwalService
  ) {
    this.user = JSON.parse(localStorage.getItem('userData'));
  }

  ngOnInit(): void {
    this.getUserInformation();
    this.passwordForm = this.formBuilder.group({
      old_pass: ['', Validators.required],
      new_pass: ['', Validators.required],
      con_pass: ['', Validators.required],
    });
  }

  getUserInformation() {
    this.service
      .getUserInformation(this.user.id)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((data) => {
        this.userInfo = data;
        this.accountForm = this.formBuilder.group({
          name: [this.userInfo.first_name, Validators.required],
          last: [this.userInfo.last_name, Validators.required],
          image: [''],
        });
      });
  }

  public goBack() {
    this.location.back();
  }

  public saveAccountData() {
    const userForm = this.accountForm.getRawValue();
    const formData = new FormData();
    formData.append('first_name', userForm.name);
    formData.append('last_name', userForm.last);
    formData.append('email', this.userInfo.email);
    formData.append('is_active', 'true');
    if (userForm.image) {
      formData.append('avatar', userForm.image.files[0]);
    }
    this.service
      .changeUserInformation(this.user.id, formData)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {
        this.swalService.fire(
          'Success',
          'Information save with success',
          'success'
        );
        if (userForm.image) {
          this.updateAvatar();
        }
      });
  }

  public changePassword(formDirective: FormGroupDirective) {
    const passwordForm = this.passwordForm.getRawValue();
    if (passwordForm.new_pass === passwordForm.con_pass) {
      const params = {
        id: this.user.id,
        old_password: passwordForm.old_pass,
        new_password: passwordForm.new_pass,
      };
      this.service
        .changePassword(params)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(() => {
          this.swalService.fire(
            'Success',
            'Information save with success',
            'success'
          );
          this.passwordForm.reset();
          formDirective.resetForm();
        });
    } else {
      this.swalService.fire(
        'Warning!',
        'Please complete the form and check the fields',
        'warning'
      );
    }
  }

  updateAvatar() {
    this.service
      .getUserInformation(this.user.id)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((data: any) => {
        this.authService.updateAvatar(data.avatar);
        location.reload();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next(null);
    this.ngUnsubscribe$.complete();
  }
}
